import http from '../utils/http';
// import axios from 'axios';
import i18n from '@/main';

const BASE_URL = 'fila-processamento-planilha';

export default {
    fetchProcessingQueuePaginated(body, page, size) {
        return http.post({
            url: `${BASE_URL}?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosFilaProcessamento')
        });
    },

    getWarehouseVatchUploadSpreadsheet(id, nomeArquivo, errorSpreadsheet) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${BASE_URL}/${id}/download-planilha?planilhaErro=${errorSpreadsheet}`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const contentDisposition =
                            response.headers['content-disposition'] || '';
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const headerMatch = filenameRegex.exec(contentDisposition);
                        const headerFilename = headerMatch ? headerMatch[1] : null;

                        const finalFilename = nomeArquivo || headerFilename || 'download';

                        fileLink.setAttribute('download', finalFilename);
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        window.URL.revokeObjectURL(fileURL);
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    }
};
